import { OnInit, Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { ISelect } from 'app/shared/models/select.model';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { IDtoDemand } from 'app/shared/models/legal/demand/dto-demand.model';
import { MatRadioChange } from '@angular/material';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { IDtoLiquidation } from 'app/shared/models/legal/dto-liquidation.model';
import { IDtoConciliatoryAppointmentBoard } from 'app/shared/models/legal/demand/dto-conciliatory-appointment.model';
import { DemandService } from 'app/views/appviews/demand.service';
import { IDtoDocument } from 'app/shared/models/request/dto-document.model';
import { DatePipe } from '@angular/common';
import { DocumentService } from 'app/shared/services/document.service';
import { LiquidationDetailComponent } from '../../../liquidation/liquidation-detail/liquidation-detail.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalRestartDemandComponet } from 'app/views/modales/demand/restart-demand/modal-restart-demand.component';
import { ModalRequestMoneyComponent } from 'app/views/modales/common/request-money/modal-request-money.component';
import { SecurityService } from 'app/shared/services/security.service';
import { IDtoSolicitudDinero } from 'app/shared/models/money/dto-solicitud-dineto.model';
import { LiquidationService } from 'app/views/appviews/liquidation.service';
import { IDtoLawyer } from 'app/shared/models/legal/dto-lawyer.model';
import { MoneyService } from 'app/views/appviews/money.service';

@Component({
    selector: '[conciliatory-appointment]',
    templateUrl: './conciliatory-appointment.template.html',
    styleUrls: ['./conciliatory-appointment.style.scss']
})
export class ConciliatoryAppointmentComponent implements OnInit, OnChanges {
    /**Validadores */
    private modalRef: BsModalRef;
    private validator = ValidatorService;
    private fsaFlags = [false];
    private flag = false;
    private errorMessages: any;
    /**Formularios */
    private formDemandProcess: FormGroup;
    /**Notificaciones */
    private configToast: any;
    /**Catalogos */
    private catalogContractTypes: Observable<ISelect[]>;
    private catalogPayrollOfficers: Observable<ISelect[]>;
    private catalogSupervisors: Observable<ISelect[]>;
    private catalogWorkingDays: Observable<IDtoCatalog[]>;
    private catalogStoreRoutes: Observable<ISelect[]>;
    /**Inputs */
    @Input() private employeeDemand: IDtoEmployee;
    @Input() private demand: IDtoDemand;
    private actionLiquidation: string;
    @Output() routeName = new EventEmitter<string>();
    private module = 'CitaConciliatoria';
    private locale: string = 'es';
    /**Securty */
    private fileNameVoucherConciliatoryAppointment: string;
    private fileVoucherConciliatoryAppointment: File;
    private fileNameVoucherDemandClosing: string;
    private fileVoucherDemandClosing: File;
    @ViewChild(LiquidationDetailComponent, { static: false }) liquidationDetailComponent;
    private showRoles: any;
    private employeeIniId: number;
    solicitudDinero: IDtoSolicitudDinero;
    lawyer: IDtoLawyer;
    step = 2;
    lockSaved: boolean;
    @Output() dataSaved = new EventEmitter<{step: number, isCompleted: boolean, savedData?: any}>();
    public constructor(private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private configGeneral: AppConfig
        , private spinner: NgxSpinnerService
        , private demandService: DemandService
        , private documentService: DocumentService
        , private configurationService: ConfigurationService
        , private identityService: IdentityService
        , private datePipe: DatePipe
        , private modalService: BsModalService
        , private securityService: SecurityService
        , private liquidationService: LiquidationService
        , private moneyService: MoneyService) {
        this.showRoles = this.securityService.getUserRolesStorage();
        if (this.showRoles !== '') {
            this.employeeIniId = this.showRoles.employeeId;
        }
        this.initializeFormDemandProcess();
        this.configToast = configGeneral.getConfigToast();
    }
    ngOnInit(): void {
        this.demandService.currentStepChallenge$.subscribe((res) => {
            let diff = res - this.step;
            if (diff > 0) {
               this.lockSaved = true;
            } else {
                this.lockSaved = false;
            }
        });
        if (this.configurationService.isReady) {
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
            });
        }
        if(this.demand.concludeDemand) {
            this.formDemandProcess.disable();
        }
        this.lockSaved = this.demandService.generateLockSaved(this.demand.step, this.step);
        this.getLawyer();
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.demand !== undefined) {
            if (changes.demand.currentValue !== undefined) {
                this.makeRequiredControls(this.demand.proceduralStageId)
                if (changes.demand.currentValue.conciliatoryAppointmentBoard) {
                    this.patchData();
                    this.obtenerDatosSolicitudDinero();
                }
            }
        }
    }
    @Input() set stageId(value: number) {
        if (value) {
            this.makeRequiredControls(value);
        }
    }
    private onFileSelectedVoucherConciliatoryAppointment(event) {

        this.fileVoucherConciliatoryAppointment = event.target.files[0];

        if (this.fileVoucherConciliatoryAppointment) {

            this.fileNameVoucherConciliatoryAppointment = this.fileVoucherConciliatoryAppointment.name;
        }
    }
    private onFileChange(event) {
        event.value = '';
    }
    private onFileSelectedVoucherDemandClosing(event) {

        this.fileVoucherDemandClosing = event.target.files[0];

        if (this.fileVoucherDemandClosing) {

            this.fileNameVoucherDemandClosing = this.fileVoucherDemandClosing.name;
        }
    }
    private radioChange($event: MatRadioChange) {
        switch ($event.source.name) {
            case 'requestMoneyLawyer':
                if ($event.value) {
                    this.formDemandProcess.get('amountLawyer').setValidators([Validators.required]);
                    //this.openModalRequestMoney('lawyer')
                } else {
                    this.formDemandProcess.get('amountLawyer').setValidators(null);
                }
                this.formDemandProcess.get('amountLawyer').updateValueAndValidity();
                break;
            case 'concludeDemand':
                this.makeRequiredFields($event.value);
                break;
        }
    }
    private makeRequiredFields(value: boolean): void {
        if (value) {
            this.formDemandProcess.get('dateTimeDemandClosing').setValidators([Validators.required]);
            this.formDemandProcess.get('voucherDemandClosing').setValidators([Validators.required]);
            this.formDemandProcess.get('commentDemandClosing').setValidators([Validators.required, Validators.maxLength(2000)]);
        } else {
            this.formDemandProcess.get('dateTimeDemandClosing').setValidators(null);
            this.formDemandProcess.get('voucherDemandClosing').setValidators(null);
            this.formDemandProcess.get('commentDemandClosing').setValidators(null);
        }
        this.formDemandProcess.get('dateTimeDemandClosing').updateValueAndValidity();
        this.formDemandProcess.get('voucherDemandClosing').updateValueAndValidity();
        this.formDemandProcess.get('commentDemandClosing').updateValueAndValidity();
    }
    private makeRequiredControls(state: number): void {
        if (state == 1) {
            this.formDemandProcess.get('receiveDocument').setValidators([Validators.required]);
            this.formDemandProcess.get('receptionDate').setValidators([Validators.required, Validators.maxLength(100)]);
            this.formDemandProcess.get('comment').setValidators([Validators.required, Validators.maxLength(2000)]);
            this.formDemandProcess.get('dateTimeAppointment').setValidators([Validators.required]);
            this.formDemandProcess.get('placeAppointment').setValidators([Validators.required, Validators.maxLength(300)]);
            this.formDemandProcess.get('voucherConciliatoryAppointment').setValidators([Validators.required]);
            this.formDemandProcess.get('requestMoneyLawyer').setValidators([Validators.required]);
            this.formDemandProcess.get('concludeDemand').setValidators([Validators.required]);

            this.formDemandProcess.get('dateTimeDemandClosing').setValidators(null);
            this.formDemandProcess.get('voucherDemandClosing').setValidators(null);
            this.formDemandProcess.get('commentDemandClosing').setValidators(null);


        } else {
            this.formDemandProcess.get('dateTimeDemandClosing').setValidators([Validators.required]);
            this.formDemandProcess.get('voucherDemandClosing').setValidators([Validators.required]);
            this.formDemandProcess.get('commentDemandClosing').setValidators([Validators.required, Validators.maxLength(2000)]);

            this.formDemandProcess.get('receiveDocument').setValidators(null);
            this.formDemandProcess.get('receptionDate').setValidators(null);
            this.formDemandProcess.get('comment').setValidators(null);
            this.formDemandProcess.get('dateTimeAppointment').setValidators(null);
            this.formDemandProcess.get('placeAppointment').setValidators(null);
            this.formDemandProcess.get('voucherConciliatoryAppointment').setValidators(null);
            this.formDemandProcess.get('requestMoneyLawyer').setValidators(null);
            this.formDemandProcess.get('concludeDemand').setValidators(null);
        }

        this.formDemandProcess.get('receiveDocument').updateValueAndValidity();
        this.formDemandProcess.get('receptionDate').updateValueAndValidity();
        this.formDemandProcess.get('comment').updateValueAndValidity();
        this.formDemandProcess.get('dateTimeAppointment').updateValueAndValidity();
        this.formDemandProcess.get('placeAppointment').updateValueAndValidity();
        this.formDemandProcess.get('voucherConciliatoryAppointment').updateValueAndValidity();
        this.formDemandProcess.get('requestMoneyLawyer').updateValueAndValidity();
        this.formDemandProcess.get('concludeDemand').updateValueAndValidity();

        this.formDemandProcess.get('dateTimeDemandClosing').updateValueAndValidity();
        this.formDemandProcess.get('voucherDemandClosing').updateValueAndValidity();
        this.formDemandProcess.get('commentDemandClosing').updateValueAndValidity();
    }
    private initializeFormDemandProcess() {
        this.formDemandProcess = this.formBuilder.group({
            receiveDocument: [null, [Validators.required, Validators.maxLength(100)]],
            receptionDate: [null, [Validators.required]],
            comment: [null, [Validators.required, Validators.maxLength(2000)]],
            dateTimeAppointment: [null, [Validators.required]],
            placeAppointment: [null, [Validators.required, Validators.maxLength(300)]],
            voucherConciliatoryAppointment: [null, [Validators.required]],
            requestMoneyLawyer: [null, [Validators.required]],
            amountLawyer: [null],
            concludeDemand: [null, [Validators.required]],
            dateTimeDemandClosing: [null],
            commentDemandClosing: [null],
            voucherDemandClosing: [null]
        });
    }
    private submitForm() {
        if (this.formDemandProcess.valid) {

            if (this.demand.conciliatoryAppointmentBoard != null) {
                this.updateData();
            } else {
                this.saveData();
            }
        } else {
            this.snotifyService.error('Capturay y guardar primeramente los datos del proceso de demanda'
                , 'Error', this.configToast);
            this.configGeneral.touchedControls(this.formDemandProcess);
        }
    }
    private saveData(): void {
        if (this.demand.id == undefined) {
            this.snotifyService.error('Llene todos los datos para poder continuar'
                , 'Error', this.configToast);
                return;
        }
        let dto = this.formDemandProcess.value as IDtoConciliatoryAppointmentBoard;
        dto.demandId = this.demand.id;
        this.demandService.addConciliatoryAppointmentBoard(dto).subscribe(
            (x) => {
                if (x.isCorrect) {
                    this.snotifyService.success('Registro guardados correctamente'
                        , 'Éxito', this.configToast);
                    let conciliatoryAppointment = x.data as IDtoConciliatoryAppointmentBoard;
                    this.demand.conciliatoryAppointmentBoard = conciliatoryAppointment;
                    this.demand.concludeDemand = conciliatoryAppointment.concludeDemand;
                    this.demandService.concludeDemand(this.demand.concludeDemand);
                    this.demandService.currentStep(this.step);
                    this.dataSaved.emit({
                        step: this.step, // Número del paso
                        isCompleted: true,
                        savedData: conciliatoryAppointment // Los datos guardados
                      });
                    if (this.formDemandProcess.value.concludeDemand) {
                        this.uploadFileVoucherDemandClosing(this.demand.conciliatoryAppointmentBoard.id, false, this.fileVoucherDemandClosing);
                    }
                    if (this.demand.proceduralStageId == 1) {
                        this.uploadFileVoucherConciliatoryAppointment(this.demand.conciliatoryAppointmentBoard.id, false, this.fileVoucherConciliatoryAppointment);
                    } else {
                        this.uploadFileVoucherDemandClosing(this.demand.conciliatoryAppointmentBoard.id, false, this.fileVoucherDemandClosing);
                    }
                    if(conciliatoryAppointment.requestMoneyLawyer) {
                        this.sentRequestMoney();
                    }
                } else {
                    this.snotifyService.error(x.message
                        , 'Error', this.configToast);
                }
            },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private processStage(liquidation: IDtoLiquidation): void {
        //this.submitForm();
        this.liquidationDetailComponent.updateLiquidation();
    }
    private updateData(): void {
        let dto = this.formDemandProcess.value as IDtoConciliatoryAppointmentBoard;
        dto.demandId = this.demand.id;
        dto.id = this.demand.conciliatoryAppointmentBoard.id;
        dto.status = this.demand.conciliatoryAppointmentBoard.status;
        dto.creationDate = this.demand.conciliatoryAppointmentBoard.creationDate;
        this.demandService.updateConciliatoryAppointmentBoard(dto).subscribe(
            (x) => {
                if (x.isCorrect) {
                    this.demand.concludeDemand = dto.concludeDemand;
                    this.demandService.currentStep(this.step);
                    this.demandService.concludeDemand(this.demand.concludeDemand);
                    this.snotifyService.success('Registros actualizados correctamente'
                        , 'Éxito', this.configToast);
                    if (this.formDemandProcess.value.concludeDemand && this.demand.conciliatoryAppointmentBoard.documentDemandClosing == null) {
                        this.uploadFileVoucherDemandClosing(dto.id, false, this.fileVoucherDemandClosing);
                    }
                    if(dto.requestMoneyLawyer) {
                        this.sentRequestMoney();
                    }
                } else {
                    this.snotifyService.error(x.message
                        , 'Error', this.configToast);
                }
            },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private patchData(): void {
        if (this.demand.conciliatoryAppointmentBoard.dateTimeAppointment != null) {
            this.demand.conciliatoryAppointmentBoard.dateTimeAppointment = new Date(this.demand.conciliatoryAppointmentBoard.dateTimeAppointment);
        }

        this.demand.conciliatoryAppointmentBoard.receptionDate = new Date(this.demand.conciliatoryAppointmentBoard.receptionDate);
        this.demand.conciliatoryAppointmentBoard.dateTimeDemandClosing = new Date(this.demand.conciliatoryAppointmentBoard.dateTimeDemandClosing);
        this.makeRequiredFields(this.demand.conciliatoryAppointmentBoard.concludeDemand);
        this.formDemandProcess.patchValue(this.demand.conciliatoryAppointmentBoard);
        if (this.demand.conciliatoryAppointmentBoard.documentConciliatoryAppointment) {
            this.fileNameVoucherConciliatoryAppointment = this.demand.conciliatoryAppointmentBoard.documentConciliatoryAppointment.fileName;
            this.formDemandProcess.get('voucherConciliatoryAppointment').setValidators(null);
            this.formDemandProcess.get('voucherConciliatoryAppointment').updateValueAndValidity();
        }
        if (this.demand.conciliatoryAppointmentBoard.documentDemandClosing) {
            this.fileNameVoucherDemandClosing = this.demand.conciliatoryAppointmentBoard.documentDemandClosing.fileName;
            this.formDemandProcess.get('voucherDemandClosing').setValidators(null);
            this.formDemandProcess.get('voucherDemandClosing').updateValueAndValidity();
        }
    }
    private uploadFileVoucherConciliatoryAppointment(reference: number, isReplaced: boolean, file: File): void {
        this.spinner.show();
        let document = {} as IDtoDocument;
        const fileName = file.name;
        let sp = fileName.split('.').pop();
        let fileNameNew = `${this.employeeDemand.id}_ComprobanteCitaConciliatoria_${this.datePipe.transform(new Date(), 'ddMMyyyy')}.${sp}`;
        document.fileName = fileNameNew;
        this.fileNameVoucherConciliatoryAppointment = fileNameNew;
        document.referenceId = reference;
        document.folder = this.module;
        document.module = this.module;
        document.name = "ComprobanteCitaConciliatoria";
        document.acceptDuplicate = false;
        document.isReplaced = isReplaced;
        this.documentService.addDocument(document, file).subscribe((res) => {
            if (res.isCorrect === true) {
                this.configGeneral.newToast('Éxito', res.message, 'success');
                let document = res.data as IDtoDocument;
                //this.addModuleLog(document.id, 'addDocument', 'documents');
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
            this.spinner.hide();
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private uploadFileVoucherDemandClosing(reference: number, isReplaced: boolean, file: File): void {
        this.spinner.show();
        let document = {} as IDtoDocument;
        const fileName = file.name;
        let sp = fileName.split('.').pop();
        let fileNameNew = `${this.employeeDemand.id}_ComprobanteCierreDemanda_${this.datePipe.transform(new Date(), 'ddMMyyyy')}.${sp}`;
        document.fileName = fileNameNew;
        this.fileNameVoucherConciliatoryAppointment = fileNameNew;
        document.referenceId = reference;
        document.folder = this.module;
        document.module = this.module;
        document.name = "ComprobanteCitaConciliatoriaCierreDemanda";
        document.acceptDuplicate = false;
        document.isReplaced = isReplaced;
        this.documentService.addDocument(document, file).subscribe((res) => {
            if (res.isCorrect === true) {
                this.configGeneral.newToast('Éxito', res.message, 'success');
                let document = res.data as IDtoDocument;
                //this.addModuleLog(document.id, 'addDocument', 'documents');
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
            this.spinner.hide();
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private openModalRestartDemand() {
        const initialState = {
            stage: 'Cita conciliatoria',
            liquidationId: this.demand.liquidationId
        };
        this.modalRef = this.modalService.show(ModalRestartDemandComponet
            , Object.assign({ initialState }
                , this.configGeneral.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                // this.demand.conciliatoryAppointmentBoard = null;
                // this.formDemandProcess.reset();
                location.reload();
            }
        });
    }
    private addModuleLog(id: number, action: string, table: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = table;
        dto.module = this.module;
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
    // private openModalRequestMoney(user: string): void {
    //     if(this.demand.conciliatoryAppointmentBoard == null) {
    //         this.configGeneral.newToast('Validación', 'No existe un registro sobre el cual hacer una petición de dinero, Asegúrese de guardar primero sus datos', 'warning');
    //         return;
    //     }
    //     const initialState = {
    //         title: 'Petición de dinero',
    //         amount: this.demand.conciliatoryAppointmentBoard.amountLawyer,
    //         module: this.module,
    //         employeeId: user == 'lawyer' ? this.demand.lawyerId : this.employeeDemand.id,
    //         employeeIniId: this.employeeIniId,
    //         id: this.demand.conciliatoryAppointmentBoard.id,
    //         user: user
    //     };
    //     this.modalRef = this.modalService.show(ModalRequestMoneyComponent
    //         , Object.assign({ initialState }
    //             , this.configGeneral.configModal));
    //     this.modalRef.content.onClose.subscribe((result) => {
    //         if (result) {
    //             //this.formDemandProcess.get('amountLawyer').setValue(result);
    //         }
    //     });
    // }
    private getLawyer(): void {
        this.spinner.show()
        this.demandService.getLawyerById( this.demand.lawyerId)
          .subscribe(
            (x) => {
              this.lawyer = x;
              this.spinner.hide();
            },
            (errMessage) => {
              this.spinner.hide();
              this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
      }
      private obtenerDatosSolicitudDinero(): void {
        this.spinner.show()
        this.solicitudDinero = {} as IDtoSolicitudDinero;
        this.liquidationService.obtenerDatosSolicitudDinero(this.demand.conciliatoryAppointmentBoard.id, this.module)
          .subscribe(
            (x) => {
              if (x.isCorrect) {
                this.solicitudDinero = x.data as IDtoSolicitudDinero;
                this.formDemandProcess.get('amountLawyer').setValue(this.solicitudDinero.cantidad);
              } else {
                this.configGeneral.newToast('Error', x.message, 'error');
              }
              this.spinner.hide();
            },
            (errMessage) => {
              this.spinner.hide();
              this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
      }
      private sentRequestMoney(): void {
        let dto = {} as IDtoSolicitudDinero;
        dto.modulo = this.module;
        dto.idRegistroModulo = this.demand.conciliatoryAppointmentBoard.id;
        dto.cantidad = this.formDemandProcess.value.amountLawyer;
        dto.idEmpleadoAutenticado = this.employeeIniId;
        dto.beneficiario = this.lawyer.name;
        dto.idClasificacionPago = 1;
        dto.cuenta = this.lawyer.bankAccount;
        dto.clabe = this.lawyer.interbankClabe;
        dto.idBanco = +this.lawyer.bank;
        dto.idTipoBeneficiario = 1;
        dto.requierePagoAnticipado = false;
    
        this.spinner.show()
        this.moneyService.agregarSolicitud(dto)
          .subscribe(
            (x) => {
              if (this.configGeneral.notificationSuccessError(x)) {

              }
              this.spinner.hide();
            },
            (errMessage) => {
              this.spinner.hide();
              this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
      }
}
